// The commands a test offers, from its status and whether its last error blocks it (backend plan, §6.2.7).
//
// Only a Created test is edited in place: one that has run (Ready) or failed is duplicated into a new Created
// test. A Failed test that blocks cannot be run again: the server refuses it too (BlockedByLastError, 422),
// so this only spares the user the refusal and is never the guard.

/**
 * @param {{ status?: string, lastErrorIsBlocking?: boolean }} test
 * @returns {{ execute: ('execute'|'executeAgain'|null), edit: boolean, duplicate: boolean, delete: boolean }}
 */
export function testCommand(test) {
  const status = test && test.status
  const isCreated = status === 'Created'
  // A test being executed (or waiting for DOXA) cannot be deleted: the server refuses it too.
  const isRunning = status === 'InProgress' || status === 'WaitingResources'
  const isRetryable = status === 'Failed' && !test.lastErrorIsBlocking

  let execute = null
  if (isCreated) {
    execute = 'execute'
  } else if (isRetryable) {
    execute = 'executeAgain'
  }

  return {
    execute,
    edit: isCreated,
    duplicate: true,
    delete: !isRunning,
  }
}
